import classNames from "classnames";
import type { MouseEvent, ReactNode } from "react";
import { useTimelineCtx } from "../ctx";
import { TimelineMarkerEnum, TimelineStyleEnum } from "../types";

interface IProps {
  className?: string;
  itemIdx: number;
  children?: ReactNode;

  onClick?: (e: MouseEvent) => void;
}

export const TimelineMarker = ({ className, children, onClick }: IProps) => {
  const {
    isHorizontal,
    isVertical,
    comboSettings: { timelineMarker, timelineStyle },
  } = useTimelineCtx();

  const isArrows = timelineMarker === TimelineMarkerEnum.Arrows;
  const isText =
    timelineMarker !== TimelineMarkerEnum.Bullets &&
    timelineMarker !== TimelineMarkerEnum.Arrows;
  const isCustomText = timelineMarker === TimelineMarkerEnum.CustomText;
  const isPath = timelineStyle === TimelineStyleEnum.Path;
  let maxWidth: string | undefined = undefined;

  if (isCustomText && isHorizontal) {
    maxWidth = "120px";
  }

  // Path + custom-text must shrink-wrap to label width — without
  // `width: fit-content` a block div inside the flex halo wrapper
  // stretches to the wrapper's width, so every marker reports the same
  // offsetWidth and the sinusoid mask can't size cuts per-label.
  const isPathCustomText = isPath && isCustomText && isHorizontal;

  return (
    <div
      data-marker-type={timelineMarker}
      className={classNames(className, {
        "timeline-item-marker": true,
        "tw-max-w-[120px]": isPath && !isPathCustomText,
        "tw-w-fit tw-break-words": isPathCustomText,
        "tw-text-center": isVertical || isPath,
        "tw-text-left": isHorizontal && !isPath,
        "tw-max-w-full": isCustomText && isVertical,
      })}
      style={{
        backgroundColor:
          !isText && !isArrows ? "var(--timeline-color)" : undefined,
        color: isText ? "var(--timeline-color)" : undefined,
        maxWidth,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
